<template>
  <div class="spacer-wrap">
    <!-- 1) Metinli special spacer: [*spacer]◣=●=◥ gibi -->
    <div v-if="repeatText" class="spacer-text">
      {{ repeatText }}
    </div>

    <!-- 2) Çizgili special spacer: -.. ___ ... --- -.- gibi -->
  </div>
</template>

<script>
export default {
  props: {
    // Eğer parent zaten "-.." / "___" gibi bir blok gönderiyorsa bozmuyoruz
    characterBlock: String,

    // ✅ Metinli spacerlar için kanal adını da alalım
    channelName: String,
  },
  computed: {
    // Kanal adından "[*spacer]...." etiketini söküp kalan metni bul
    spacerPayload() {
      var raw = String(this.channelName || "");
      // baştaki [ ... spacer ... ] kısmını kırp
      var cleaned = raw.replace(/^\[[^\]]*spacer[^\]]*\]/i, "").trim();
      return cleaned;
    },

    // Metinli spacer ise TS3 gibi tekrar üret
    repeatText() {
      var txt = this.spacerPayload;

      // boşsa metinli spacer değil
      if (!txt) return "";

      // Eğer payload aslında çizgi tiplerinden biriyse, SVG tarafına bırak
      if (
        txt === "-.." ||
        txt === "___" ||
        txt === "-.-" ||
        txt === "..." ||
        txt === "---"
      ) {
        return "";
      }

      // TS3 görünümü: ekrana sığacak kadar tekrar (uzun tutup overflow hidden yapıyoruz)
      var out = "";
      var targetLen = 300; // yeterince uzun
      while (out.length < targetLen) out += txt;

      return out;
    },

    // Karakter bloğuna göre SVG çizgi deseni
    dashArray() {
      switch (this.characterBlock) {
        case "-..":
          return "5 2 1 2 1 2";
        case "___":
          return "0";
        case "-.-":
          return "5 2 1 2";
        case "...":
          return "1 2";
        case "---":
          return "5 2";
        default:
          return "0";
      }
    },

    strokeColor() {
      return this.$vuetify.theme.dark
        ? "rgba(255,255,255,0.85)"
        : "rgba(0,0,0,0.6)";
    },
  },
};
</script>

<style scoped>
.spacer-wrap {
  width: 100%;
}

.spacer-text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden; /* ekrana sığanı göster */
  text-overflow: clip; /* kesme */
  opacity: 0.85;
  line-height: 1.1;
}

.spacer-svg {
  width: 100%;
  display: block;
}
</style>
